import type { ThemeComponentType } from '../types';

export const MultiSelect: ThemeComponentType = {
  styles: theme => ({
    input: {
      padding: '0 16px 0 16px',
      '&&:read-only': {
        backgroundColor: 'white',
      },
    },
    value: {
      color: theme.colors.violet[theme.fn.primaryShade()],
      backgroundColor: theme.colors[theme.primaryColor][1],
    },
    item: {
      padding: theme.other.spacing(1, 2),
      fontSize: theme.fontSizes.lg,
      '&[data-selected]': {
        fontWeight: 600,
        backgroundColor: theme.colors[theme.primaryColor][1],
        color: 'inherit',
      },
      '&[data-hovered]': {
        backgroundColor: theme.colors[theme.primaryColor][1],
      },
    },
  }),
};
